export const styles = {
  top: "10%",
};
